// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== CAROUSEL CONTAINER ==================== */
.carousel-frame-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 500px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 12px;
  background: rgba(36, 36, 45, 0.2);
  padding: 1rem;
  box-sizing: border-box;
}

.carousel-empty {
  text-align: center;
  padding: 3rem;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
}

/* ==================== SINGLE VIEW ==================== */
.carousel-single-view {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

/* ==================== CAROUSEL MEDIA ==================== */
.carousel-media {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
  display: block;
}

.carousel-media-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-audio {
  width: 85%;
  max-width: 500px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.3) 0%, rgba(76, 29, 149, 0.2) 100%);
  border: 1px solid rgba(168, 139, 250, 0.2);
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.carousel-audio audio {
  width: 100%;
}

.waveform-container {
  width: 100%;
  margin-bottom: 1rem;
}

/* ==================== CAPTION ==================== */
.carousel-caption {
  position: absolute;
  bottom: 10%;
  left: 5%;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  max-width: 80%;
  pointer-events: none;
  z-index: 5;
}

/* ==================== NAVIGATION ==================== */
.carousel-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  font-size: 1.5rem;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.carousel-button:hover {
  background-color: rgba(124, 58, 237, 0.8);
  transform: translateY(-50%) scale(1.1);
}

.carousel-button.prev { left: 1.5rem; }
.carousel-button.next { right: 1.5rem; }

/* ==================== DOTS ==================== */
.carousel-dots {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 100;
}

.carousel-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-dot.active {
  background-color: #a78bfa;
  transform: scale(1.3);
}

/* ==================== DETAIL POPUP ==================== */
.carousel-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.carousel-detail-modal {
  position: relative;
  display: flex;
  width: 90vw;
  max-width: 1200px;
  height: 85vh;
  max-height: 800px;
  background: rgba(20, 20, 28, 0.98);
  border-radius: 12px;
  overflow: hidden;
}

.carousel-detail-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
}

.carousel-detail-close:hover {
  background: rgba(124, 58, 237, 0.8);
  transform: scale(1.1);
}

/* ---------- LEFT: Media ---------- */
.carousel-detail-media-section {
  flex: 1.5 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.carousel-detail-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.carousel-detail-audio {
  width: 80%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.3) 0%, rgba(76, 29, 149, 0.2) 100%);
  border-radius: 12px;
}

.carousel-detail-audio audio { width: 100%; }

/* ---------- RIGHT: Sidebar ---------- */
.carousel-detail-sidebar {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  max-width: 420px;
  height: 100%;
  overflow: hidden;
}

.carousel-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.carousel-detail-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.carousel-detail-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(168, 139, 250, 0.3);
}

.carousel-detail-user-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.carousel-detail-username {
  font-weight: 600;
  font-size: 0.9rem;
}

.carousel-detail-location {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 768px) {
  .carousel-frame-container {
    height: 400px;
    padding: 0.75rem;
  }

  .carousel-button {
    width: 35px;
    height: 35px;
    font-size: 1.2rem;
  }

  .carousel-detail-modal {
    flex-direction: column;
    width: 95vw;
    height: 90vh;
  }

  .carousel-detail-media-section {
    flex: 1 1;
    max-height: 50%;
  }

  .carousel-detail-sidebar {
    flex: 1 1;
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .carousel-frame-container {
    height: 350px;
    padding: 0.5rem;
  }

  .carousel-detail-modal {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Carousel/Carousel.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,4FAA4F;EAC5F,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA,wBAAwB,YAAY,EAAE;AACtC,wBAAwB,aAAa,EAAE;;AAEvC,mDAAmD;AACnD;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4FAA4F;EAC5F,mBAAmB;AACrB;;AAEA,+BAA+B,WAAW,EAAE;;AAE5C,yCAAyC;AACzC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":["/* ==================== CAROUSEL CONTAINER ==================== */\n.carousel-frame-container {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  height: 500px;\n  margin: 0 auto;\n  overflow: hidden;\n  border-radius: 12px;\n  background: rgba(36, 36, 45, 0.2);\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.carousel-empty {\n  text-align: center;\n  padding: 3rem;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 14px;\n}\n\n/* ==================== SINGLE VIEW ==================== */\n.carousel-single-view {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* ==================== CAROUSEL MEDIA ==================== */\n.carousel-media {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  display: block;\n}\n\n.carousel-media-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel-audio {\n  width: 85%;\n  max-width: 500px;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, rgba(124, 58, 237, 0.3) 0%, rgba(76, 29, 149, 0.2) 100%);\n  border: 1px solid rgba(168, 139, 250, 0.2);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.carousel-audio audio {\n  width: 100%;\n}\n\n.waveform-container {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n/* ==================== CAPTION ==================== */\n.carousel-caption {\n  position: absolute;\n  bottom: 10%;\n  left: 5%;\n  color: white;\n  font-size: 1rem;\n  font-weight: bold;\n  background-color: rgba(0, 0, 0, 0.7);\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  max-width: 80%;\n  pointer-events: none;\n  z-index: 5;\n}\n\n/* ==================== NAVIGATION ==================== */\n.carousel-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  font-size: 1.5rem;\n  width: 45px;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 100;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.carousel-button:hover {\n  background-color: rgba(124, 58, 237, 0.8);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.carousel-button.prev { left: 1.5rem; }\n.carousel-button.next { right: 1.5rem; }\n\n/* ==================== DOTS ==================== */\n.carousel-dots {\n  position: absolute;\n  bottom: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 10px;\n  z-index: 100;\n}\n\n.carousel-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.carousel-dot.active {\n  background-color: #a78bfa;\n  transform: scale(1.3);\n}\n\n/* ==================== DETAIL POPUP ==================== */\n.carousel-detail-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.carousel-detail-modal {\n  position: relative;\n  display: flex;\n  width: 90vw;\n  max-width: 1200px;\n  height: 85vh;\n  max-height: 800px;\n  background: rgba(20, 20, 28, 0.98);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.carousel-detail-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 40px;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  transition: all 0.3s ease;\n}\n\n.carousel-detail-close:hover {\n  background: rgba(124, 58, 237, 0.8);\n  transform: scale(1.1);\n}\n\n/* ---------- LEFT: Media ---------- */\n.carousel-detail-media-section {\n  flex: 1.5;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.carousel-detail-media {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.carousel-detail-audio {\n  width: 80%;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  background: linear-gradient(135deg, rgba(124, 58, 237, 0.3) 0%, rgba(76, 29, 149, 0.2) 100%);\n  border-radius: 12px;\n}\n\n.carousel-detail-audio audio { width: 100%; }\n\n/* ---------- RIGHT: Sidebar ---------- */\n.carousel-detail-sidebar {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  max-width: 420px;\n  height: 100%;\n  overflow: hidden;\n}\n\n.carousel-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n}\n\n.carousel-detail-user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.carousel-detail-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid rgba(168, 139, 250, 0.3);\n}\n\n.carousel-detail-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.carousel-detail-username {\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.carousel-detail-location {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n}\n\n/* ==================== RESPONSIVE ==================== */\n@media (max-width: 768px) {\n  .carousel-frame-container {\n    height: 400px;\n    padding: 0.75rem;\n  }\n\n  .carousel-button {\n    width: 35px;\n    height: 35px;\n    font-size: 1.2rem;\n  }\n\n  .carousel-detail-modal {\n    flex-direction: column;\n    width: 95vw;\n    height: 90vh;\n  }\n\n  .carousel-detail-media-section {\n    flex: 1;\n    max-height: 50%;\n  }\n\n  .carousel-detail-sidebar {\n    flex: 1;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .carousel-frame-container {\n    height: 350px;\n    padding: 0.5rem;\n  }\n\n  .carousel-detail-modal {\n    width: 100vw;\n    height: 100vh;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
